import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import './Password.css';
// @ts-ignore
import background from './password_background.jpg';
import TextField from '../TextField/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import logo from '../Login/scisports-logo.svg';
import usersService from '../../services/users';

const Wrapper = styled.div`
  width: 479px;
  height: 100%;
  overflow: hidden;
`;

const Semitransparent = styled.div`
  height: 100%;
  width: 500px;
  background: url(${background}) no-repeat center center fixed;
  filter: blur(10px);
  top: 0px;
  left: -100px;
  right: -100px;
  overflow: hidden;
  background-size: cover;
`;

const PasswordWrapper = styled.div`
  height: 100%;
`;

const PasswordDialog = styled.div`
  position: absolute;
  width: 461px;
  height: 595px;
  left: 160px;
  top: calc(50% - 300px);
  background-color: white;
`;

const InmotioLogo = styled.img`
  padding-top: 39px;
  display: block;
  margin: auto;
  width: 350px;
`;

const PasswordField = styled(TextField)`
  margin: auto;
`;

const PasswordButtonWrapper = styled.div`
  width: 370px;
  margin: auto;
  margin-top: 63px;
`;

const PasswordTextWrapper = styled.div`
  width: 370px;
  margin: auto;
  margin-top: 32px;
`;

type TParams = { history: any, match: any };

const Verify: React.FunctionComponent<TParams> = props => {
  let [password, setPassword] = useState('');
  let [showPassword, setShowPassword] = useState(false);
  let [password2, setPassword2] = useState('');
  let [showPassword2, setShowPassword2] = useState(false);
  const { history, match } = props;

  const { enqueueSnackbar } = useSnackbar();

  const confirm = async () => {
    if (password !== password2) {
      enqueueSnackbar("The passwords don't match", { variant: 'error', autoHideDuration: 3000 });
    } 
    else if (!password) {
      enqueueSnackbar("Password required", { variant: 'error', autoHideDuration: 3000 });
    }
    else {
      try
      {
        await usersService.confirm({
          token: match.params.token,
          password: password
        });

        enqueueSnackbar("User confirmed", { variant: 'success', autoHideDuration: 3000 });
        history.push('/login');
      }
      catch {
        enqueueSnackbar('Password failed', { variant: 'error', autoHideDuration: 3000 })
      }
    }
  };

  useEffect(() => {
    document.body.classList.add('login-body');
    return () => {
      document.body.classList.remove('login-body');
    };
  });

  return (
    <PasswordWrapper>
      <Wrapper>
        <Semitransparent />
      </Wrapper>
      <PasswordDialog>
        <InmotioLogo src={logo} />
        <PasswordTextWrapper>
          Please enter a new password for accessing the Inmotio Portal. You will need this password to
          access the portal in the future.
        </PasswordTextWrapper>
        <PasswordField
          id="password"
          label="Password"
          value={password}
          width={370}
          onChange={(event) => setPassword(event.target.value)}
          type={showPassword ? 'text' : 'password'}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="Toggle password visibility" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <PasswordField
          id="password"
          label="Re-enter password"
          value={password2}
          width={370}
          onChange={(event) => setPassword2(event.target.value)}
          type={showPassword2 ? 'text' : 'password'}
          inputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="Toggle password visibility" onClick={() => setShowPassword2(!showPassword2)}>
                  {showPassword2 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <PasswordButtonWrapper>
          <Button size="large" variant="contained" color="primary" fullWidth onClick={confirm}>
            Set password
          </Button>
        </PasswordButtonWrapper>
      </PasswordDialog>
    </PasswordWrapper>
  );
};

export default Verify;
